import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section } from './Shared';
export type TestimonialProps = {
  initials: string;
  name: string;
  location: string;
  product?: string;
  text: string;
  accent?: 'green' | 'rose' | 'lavender';
};
const accents: Record<NonNullable<TestimonialProps['accent']>, string> = {
  green: 'bg-brand-green',
  rose: 'bg-brand-rose',
  lavender: 'bg-brand-lavender'
};
export function TestimonialCard({
  initials,
  name,
  location,
  product,
  text,
  accent = 'green'
}: TestimonialProps) {
  return <article className="paper-panel flex h-full flex-col rounded-2xl border-l-4 border-l-brand-greenMid p-6 md:p-8" data-id="element-275" data-mp="31yl5r31djqnt">
      <div className="mb-4 flex items-center" data-id="element-276" data-mp="2x2w5exhj65qg">
        <div className={`mr-4 flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-sm font-bold text-brand-cream ring-1 ring-brand-gold/40 md:text-lg ${accents[accent]}`} data-id="element-277" data-mp="2s2i21sqvjjyr">
          {initials}
        </div>
        <div data-id="element-278" data-mp="q892ppc9p5j0">
          <div className="mb-1 flex text-brand-amber" data-id="element-279" data-mp="q8irxaphn8nn">
            {Array.from({
            length: 5
          }, (_, index) => <StarIcon key={index} className="h-4 w-4 fill-current" data-id="element-280" data-mp="m4rmy9btd84u" />)}
          </div>
          <p className="font-semibold text-brand-text md:text-lg" data-id="element-281" data-mp="780ivmr7388w">{name}</p>
          <p className="text-xs text-brand-muted md:text-sm" data-id="element-282" data-mp="7a4y30ujntoh">
            {location}
            {product ? ` — ${product}` : ''}
          </p>
        </div>
      </div>
      <p className="flex-grow font-serif text-sm italic leading-relaxed text-brand-textLight md:text-base" data-id="element-283" data-mp="zxr38djf76dg">“{text}”</p>
    </article>;
}
const testimonials: TestimonialProps[] = [{
  initials: 'MV',
  name: 'María V.',
  location: 'Mendoza',
  product: 'Terapeuta holística',
  accent: 'green',
  text: 'Por primera vez tengo un sistema completo para mis sesiones. Mis pacientes perciben la diferencia desde el primer momento y cuando les explico qué flores usé y por qué, sienten que están en manos de una profesional real.'
}, {
  initials: 'CL',
  name: 'Carolina L.',
  location: 'Buenos Aires',
  product: 'Terapeuta energética',
  accent: 'rose',
  text: 'El Escudo del Terapeuta solo ya vale todo el pack. Antes llegaba a casa agotada sin entender por qué. Ahora, con las técnicas de blindaje, la diferencia es enorme.'
}, {
  initials: 'SM',
  name: 'Sofía M.',
  location: 'Rosario',
  product: 'Terapeuta en formación',
  accent: 'lavender',
  text: 'Recién empezaba y el Botiquín Bach me dio la estructura que necesitaba desde la primera sesión. Llegué al consultorio con criterio desde el día uno.'
}];
export function InitialTestimonials() {
  return <Section className="pb-14 pt-6" data-id="element-284" data-mp="14r8xcuixm3jr">
      <div className="mx-auto max-w-3xl" data-id="element-285" data-mp="10s9tzecumeuf">
        <TestimonialCard {...testimonials[0]} data-id="element-286" data-mp="10tb7dphc7dfb" />
      </div>
    </Section>;
}
export function MoreTestimonials() {
  return <Section className="pb-16 pt-8" data-id="element-287" data-mp="vuhqdn2ud4ae">
      <div className="mb-10 text-center" data-id="element-288" data-mp="qtak5sgckd5u">
        <h2 className="font-display text-2xl font-bold text-brand-green md:text-4xl" data-id="element-289" data-mp="quc3slbfi7z6">
          ❤️ LO QUE DICEN LOS TERAPEUTAS QUE YA LO TIENEN
        </h2>
      </div>
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-6 md:grid-cols-3" data-id="element-290" data-mp="37exm0ww0q5mb">
        {testimonials.map(testimonial => <TestimonialCard key={testimonial.initials} {...testimonial} data-id="element-291" data-mp="3cfv3t8d48xna" />)}
      </div>
    </Section>;
}